import { z } from 'zod';
export const insuranceClaimsFinanceBillingCapability = 'finance.project-billing-summary.v1';
export const insuranceClaimsFinanceBillingSlot = 'insurance-claims.project-billing-summary';
export const insuranceClaimsFinanceBillingProviderId = 'finance.server.insurance-claims-billing';
const idSchema = z.string().uuid();
const countSchema = z.number().int().nonnegative();
const centsSchema = z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER);
export const insuranceClaimsFinanceBillingProviderRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(insuranceClaimsFinanceBillingCapability),
    resourceType: z.literal('insurance-claims.claim'),
    resourceId: idSchema,
    projectId: idSchema,
});
export const insuranceClaimsFinanceBillingProviderResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(insuranceClaimsFinanceBillingCapability),
    projectId: idSchema,
    currencyCode: z.literal('USD'),
    invoiceCount: countSchema,
    nonvoidInvoiceCount: countSchema,
    byStatus: z.strictObject({
        draft: countSchema,
        sent: countSchema,
        partial: countSchema,
        paid: countSchema,
        void: countSchema,
    }),
    totalBilledCents: centsSchema,
    totalPaidCents: centsSchema,
    totalWrittenOffCents: centsSchema,
    totalDueCents: centsSchema,
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
    observedAt: z.string().datetime({ offset: true }).nullable(),
}).superRefine((value, context) => {
    const statusTotal = Object.values(value.byStatus).reduce((sum, count) => sum + count, 0);
    const due = value.totalBilledCents - value.totalPaidCents - value.totalWrittenOffCents;
    if (statusTotal !== value.invoiceCount ||
        value.invoiceCount - value.byStatus.void !== value.nonvoidInvoiceCount ||
        due < 0 || due !== value.totalDueCents) {
        context.addIssue({ code: 'custom', message: 'Finance billing facts do not reconcile.' });
    }
});
export const insuranceClaimsFinanceBillingUnavailableReasonSchema = z.enum([
    'not-installed',
    'not-enabled',
    'permission-denied',
    'provider-invalid',
    'provider-failed',
]);
export const insuranceClaimsFinanceBillingAvailabilitySchema = z.discriminatedUnion('state', [
    insuranceClaimsFinanceBillingProviderResponseSchema,
    z.strictObject({
        state: z.literal('unavailable'),
        capability: z.literal(insuranceClaimsFinanceBillingCapability),
        reasonCode: insuranceClaimsFinanceBillingUnavailableReasonSchema,
    }),
]);
//# sourceMappingURL=insurance-claims-finance-billing.contract.js.map